<template>
  <div id="join-page">
      <CreateYourAccount />
  </div>
</template>

<script>
  import CreateYourAccount from "./CreateYourAccount";


  export default {
    name: 'JoinPage',
    components: {
      CreateYourAccount,
    },
    data() {

      return {

      }
      },
    methods: {

    }
  }
</script>